var MENU_LINKS = [
  
  /*------------------- Menu Col1 ----------------------*/
  [{
      caption: "Summer Gifts",
      link: '/collections/all/summer'
  },
  {
      caption: "Covid Corner",
      link: '/collections/all/covid19'
  },
  {
      caption: "Back to School",
      link: '/collections/all/back_to_school'
  }, 
  {
      caption: "New House",
      link: '/collections/all/housewarming'
  }],
  /*------------------- Menu Col2 ----------------------*/
  [{
    caption: "Birthday",
    link: "/pages/bday"
  },
  {
    caption: "Baby",
    link: "/collections/all/baby"
  },
  {
    caption: "Thank You",
    link: "/collections/all/thank_you"
  },
  {
    caption: "Recovery",
    link: "/collections/all/recovery"
  },
  {
    caption: "Graduation",
    link: "/collections/all/graduation"
  },
   {
    caption: "Engagement",
    link: "/collections/all/engagement"
  },
   {
    caption: "Bridesmaid Proposal",
    link: "/collections/all/bridesmaid_proposal"
  },
   {
    caption: "Lingerie Shower",
    link: "/collections/all/lingerie_shower"
  },
   {
    caption: "Bridesmaid Gifts",
    link: "/collections/all/bridal_party"
  },
   {
    caption: "Groomsmen Gifts",
    link: "/collections/all/groomsmen"
  },
   {
    caption: "Anniversary",
    link: "/pages/anniversary"
  },   
  {
    caption: "All Things Wedding",
    link: "/collections/../"
  }],
  
  /*------------------- Menu Col3 ----------------------*/
  [{
    caption: "Flower Delivery",
    link: "/collections/all/flowers"
  },
  {
    caption: "Food Delivery",
    link: "/collections/all/food_delivery"
  },
  {
    caption: "Handbags",
    link: "/collections/all/handbags"
  },
  {
    caption: "Jewelry",
    link: "/collections/all/jewelry"
  },
  {
    caption: "Self Care",
    link: "/collections/all/self_care"
  },
  {
    caption: "Cards",
    link: "/collections/all/cards_and_wrap"
  },
  {
    caption: "Gifts For The Home",
    link: "/collections/all/home_gifts"
  },
  {
    caption: "Monogrammed and Personalized",
    link: "/collections/all/personalized"
  },
  {
    caption: "Stationery Sets",
    link: "/collections/all/stationery"
  },
  {
    caption: "Classic Menswear",
    link: "/collections/all/classic_menswear"
  },
  {
    caption: "Classic Womenswear",
    link: "/collections/all/classic_womenswear"
  }],
  
  /*------------------- Menu Col4 ----------------------*/
   [{
    caption: "Complimentary Wrapping",
    link: "/collections/all/free_wrapping"
  },
  {
    caption: "Complementary Note Enclosure",
    link: "/collections/all/free_message"
  },
  {
    caption: "Amazon Prime Picks",
    link: "https://www.amazon.com/shop/gramercygiftguide"
  },
     {
    caption: "Etsy Picks",
    link: "/collections/all/Etsy"
  },
     {
    caption: "Female Founded",
    link: "/collections/all/female_founded_brands"
  },
   {
    caption: "Sustainably Minded",
    link: "/collections/all/sustainable"
  },
   {
    caption: "Gifts that Give Back",
    link: "/collections/all/give_back"
  }],
]